import { Component, computed, inject, input } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatSelectModule } from '@angular/material/select'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { RouterModule } from '@angular/router'
import { CommonModule } from '@angular/common'
import { I18nService } from 'src/app/core/services/i18n.service'
import { I18nText } from 'src/app/core/interfaces/i18n.service'


@Component({
  selector: 'app-section',
  template: `
    @if (enabled()) {
      <section class="SectionBasic" [style]="styles().container" data-testid="section">
          <div class="container">
            @let i18nMainText = i18n.get(mainText());
            @let i18nSubText = i18n.get(subText());
            @if (i18nMainText || i18nSubText) {
              <div
                class="SectionBasic__content"
                [style]="styles().content"
              >
                @if (i18nMainText) {
                  <h2
                    class="SectionBasic__heading"
                    [class]="mainTextSize() || 'h4'"
                    [style]="styles().mainText"
                  >{{i18nMainText}}</h2>
                }
                @if (i18nSubText) {
                  <div
                    class="SectionBasic__subheading body-1"
                    [style]="styles().subText"
                  >{{i18nSubText}}</div>
                }
              </div>
            }
            <ng-content></ng-content>
          </div>
      </section>
    }
  `,
  styles: [`
    @use "sass:map";
    @import 'src/assets/_colors';
    .SectionBasic {
        padding-top: 60px;
        padding-bottom: 80px;
        background-color: map-get($light, gray, 1);

        &__content {
          display: flex;
          flex-direction: column;
          gap: 12px;
          margin-bottom: 32px;
        }

        &__heading {
          font-family: var(--theme-headings-font-family);
        }

        &__subheading {
          font-family: var(--theme-body-font-family);
        }
    }
  `],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatSelectModule,
    MatSlideToggleModule,
  ]
})
export class SectionComponent {
  protected i18n = inject(I18nService)

  enabled = input<boolean>(false)
  mainText = input<I18nText | string>('')
  mainTextSize = input<string>('')
  subText = input<I18nText | string>('')
  styles = input<any>({})
}
